import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  searchCategoriesRequest,
  updateFilterParams,
  changeFilterModalStatus,
  activateInactivateCategoriesRequest,
  clearEditCategoryStepper,
  setEditCategory,
} from '../../redux/categories/actions';
import {
  listsDataRequest,
} from '../../redux/lists/actions';

import CategoriesScreen from './CategoriesScreen';

const mapStateToProps = state => ({
  categories: state.categories.categories,
  isLoading: state.categories.isLoading,
  loadingLists: state.lists.isLoading,
  failure: state.categories.failure,
  activateInactivateFailure: state.categories.activateInactivateFailure,
  filterModalIsOpen: state.categories.filterModalIsOpen,
  filterParams: state.categories.filterParams,
  categoriesList: state.lists.data.categories,
  saveStatus: state.categories.saveStatus,
});

const mapDispatchToProps = dispatch => ({
  searchCategoriesRequest: requestParams => dispatch(searchCategoriesRequest(requestParams)),
  updateFilterParams: filterParams => dispatch(updateFilterParams(filterParams)),
  changeFilterModalStatus: active => dispatch(changeFilterModalStatus(active)),
  activateInactivateCategoriesRequest: evaluateds => dispatch(activateInactivateCategoriesRequest(evaluateds)),
  clearEditCategoryStepper: () => dispatch(clearEditCategoryStepper()),
  setEditCategory: evaluated => dispatch(setEditCategory(evaluated)),
  listsDataRequest: requestParams => dispatch(listsDataRequest(requestParams)),
});

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(CategoriesScreen),
);
